import { render, staticRenderFns } from "./TabChain.vue?vue&type=template&id=0afcb286&scoped=true&"
import script from "./TabChain.vue?vue&type=script&lang=js&"
export * from "./TabChain.vue?vue&type=script&lang=js&"
import style0 from "./TabChain.vue?vue&type=style&index=0&id=0afcb286&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afcb286",
  null
  
)

export default component.exports